var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    !_vm.edit && _vm.client
      ? _c("div", [
          _c("div", [
            _c("strong", [_vm._v(_vm._s(_vm.client.name))]),
            _vm._v(" "),
            _vm.client.email
              ? _c("p", { staticClass: "text-muted" }, [
                  _vm._v(_vm._s(_vm.client.email)),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.client.created_at
              ? _c("p", { staticClass: "text-muted" }, [
                  _vm._v(_vm._s(_vm.client.created_at)),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c(
            "div",
            _vm._l(_vm.phones, function (phone, index) {
              return phone.phone
                ? _c("div", { key: index }, [
                    _c("p", [
                      _c("i", { staticClass: "icon-fa icon-fa-phone-square" }),
                      _vm._v(" "),
                      _c("strong", [
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(_vm.printPhone(phone)),
                          },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    phone.phone.comment
                      ? _c("p", { staticClass: "text-muted" }, [
                          _vm._v(_vm._s(phone.phone.comment)),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e()
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "text-right" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-info btn-sm",
                on: {
                  click: function ($event) {
                    return _vm.editClient()
                  },
                },
              },
              [_vm._v("Редактировать")]
            ),
          ]),
        ])
      : _c(
          "div",
          [
            _c("div", { staticClass: "pb-1" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.forEdit.client.name,
                    expression: "forEdit.client.name",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text", placeholder: "Имя клиента" },
                domProps: { value: _vm.forEdit.client.name },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.forEdit.client, "name", $event.target.value)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _vm._l(_vm.forEdit.phones, function (phone, index) {
              return phone
                ? _c("div", { staticClass: "row pb-1" }, [
                    _c("div", { staticClass: "col-md-5" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: phone.phone.full_phone,
                            expression: "phone.phone.full_phone",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", placeholder: "Телефон" },
                        domProps: { value: phone.phone.full_phone },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              phone.phone,
                              "full_phone",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-7 flex phone_list" },
                      [
                        _vm.search && !_vm.forEdit.client.id
                          ? _c(
                              "div",
                              [
                                _c(
                                  "vue-ladda",
                                  {
                                    attrs: {
                                      "button-class": "btn btn-sm btn-info",
                                      "data-style": "zoom-in",
                                      loading: _vm.searchLoading,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.searchByPhone(index)
                                      },
                                    },
                                  },
                                  [_vm._v("Поиск\n          ")]
                                ),
                              ],
                              1
                            )
                          : _c("div", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: phone.phone.comment,
                                    expression: "phone.phone.comment",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  placeholder: "Комментарий к телефону",
                                },
                                domProps: { value: phone.phone.comment },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      phone.phone,
                                      "comment",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                        _vm._v(" "),
                        index === 0
                          ? [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-success btn-sm",
                                  on: {
                                    click: function ($event) {
                                      return _vm.addPhoneRow()
                                    },
                                  },
                                },
                                [_vm._v("+")]
                              ),
                            ]
                          : [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-danger btn-sm",
                                  on: {
                                    click: function ($event) {
                                      return _vm.addPhoneRow(false, index)
                                    },
                                  },
                                },
                                [_vm._v("-")]
                              ),
                            ],
                      ],
                      2
                    ),
                  ])
                : _vm._e()
            }),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex justify-content-between" },
              [
                _vm.allowToUpdateClient
                  ? _c(
                      "vue-ladda",
                      {
                        attrs: {
                          "button-class": "btn btn-sm btn-info",
                          "data-style": "zoom-in",
                          loading: _vm.savingData,
                        },
                        on: { click: _vm.updateLocalClient },
                      },
                      [_vm._v("Обновить клиента\n      ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.client
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-primary btn-sm",
                        attrs: { disabled: _vm.savingData },
                        on: {
                          click: function ($event) {
                            return _vm.editClient(false)
                          },
                        },
                      },
                      [_vm._v("Назад")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
          2
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }